<template>
  <div style="max-width:600px;margin:0 auto;background: #fff;">
    <div class="header">
      <div class="title">{{activity_name}}</div>
    </div>
    <div class="content_body2" v-if="!success">
        <div class="sign_title">酷丁编程</div>
        <div style="width:80%;margin:20px auto 0;">
            <el-form ref="model" :rules="models" :model="model">
                <el-form-item style="margin-bottom: 10px;padding:5px 10px;" prop="phone">
                    <div class="options">
                        <el-input type="text" maxlength="11" class="text_ipt" v-model="model.phone" placeholder="请输入手机号签到"></el-input>
                    </div>
                </el-form-item>
                <el-form-item style="margin-bottom: 10px;padding:5px 10px;">
                    <el-button type="primary" @click="getSubmit" style="width:100%;">立即签到</el-button>
                </el-form-item>
            </el-form>
        </div>

    </div>
    <div class="content_success" v-else>
        <div class="success_box"><span class="el-icon-success"></span></div>
        <div class="success_title">签到成功</div>
    </div>
  </div>
</template>
<style>
  .el-select-dropdown{
    width: 96%!important;
    left: 2% !important;
  }
</style>
<script>
import {appointmentsign} from "@/api/appointment";
export default {
  name: "questionnaire",
  data() {
    return {
      success:false,
      activity_name:'',
      id:0,
      model:{
        phone:'',
      },
      models:{
          phone:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.activity_name = this.$route.query.name;
  },
  methods: {
    getSubmit(){
        this.$refs['model'].validate((valid) => {
          if(valid){
            let self = this;
            let data = {
                id:self.id,
                phone:self.model.phone,
            }
            appointmentsign(data).then(response=>{
                if(response.code == 0){
                    self.success = true;
                }else{
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message:  response.msg
                    });
                }
            })
          }
      })
    }
  }
};
</script>

<style scoped>
  @import "../static/css/questionnaire.css";
</style>
